<template>
  
  <div class="container">
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col-12">
        <div class="row nav_Breadcrumb">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('mySubscription.breadcrumb_1')}}</router-link></li>
                <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="almarai-bold active mx-3" aria-current="page">{{$t('mySubscription.breadcrumb_2')}}</li>
              </ol>
            </nav>
          </div>
        </div>

        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
        <div class="row pt-2" v-if="isFeatured">
          <div class="col-12">
            <div class="row justify-content-center">
              <div class="col-12 text-center mb-2">
                <div class="avatar-img" :style="`background-image: url(${(GET_USER_DATA.avatar)? BASE_URL+'uploads/'+GET_USER_DATA.avatar : '/assets/images/avatar.png'});`">
                </div>
              </div>
              <div class="col-12 text-center">
                <!-- <label for="logo">
                  <i class="fa-solid mouse-hand fa-circle-user logoProfile img_Profile"></i>
                </label> -->
                <div class="pb-2 almarai-bold">{{ user.name }}</div>
                <div class="row justify-content-center pb-2">
                  <div class="col-auto owner">
                    <img src="/assets/images/icons/star.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('mySubscription.distinguishedOwner')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-11 col-md-5">
                <label class="p-content">{{$t('mySubscription.terminationDate')}}</label>
                <div class="input-style form-control">{{moment(date).format('L')}}</div>
              </div>
            </div>
            <div class="row pt-2 justify-content-center">
              <div class="col-11 col-md-5">
                <label class="p-content">{{$t('mySubscription.SubscriptionFee')}}</label>
                <div class="input-style form-control">{{price}}</div>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div class="col-11 col-md-5">
                <div class="btn-gold" @click.prevent="paymentMethod">{{$t('mySubscription.renewSubscription')}}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="row pt-2">
          <div class="col">
            <div class="text-center">
              <img src="/assets/images/icons/star.png" class="star-Style" alt="">
              <h3 class="pt-3">{{$t('mySubscription.propertiesStand')}}</h3>
              <h6 class="small-Font pt-2">{{$t('mySubscription.customerService')}}</h6>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-auto">
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.fastestCustomer')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.lowerCommission')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.Faster_Stronger')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.accountManager')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.forgiveness_Contract')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.reducedMaintenance')}}</span>
                </div>
                <div class="pt-2">
                  <img src="/assets/images/icons/tick-circle.png" class="max-24" alt="">
                  <span class="mx-2">{{$t('mySubscription.freeProperty')}}</span>
                </div>
              </div>
            </div>
            <div class="row justify-content-center pt-4">
              <div class="col-11 col-md-5">
                <div class="btn-gold" @click.prevent="paymentMethod">{{$t('mySubscription.subscribeNow')}} {{price}} {{$t('mySubscription.subscribeNowt')}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- begin:subscription Successful Confirm -->
          <div class="row pt-2 justify-content-center" v-if="SuccessfulConfirm">
            <div class="col-11 col-md-6">
              <div class="row">
                <div class="col text-center">
                  <div><img src="/assets/images/tick-circle.png" class="img-fluid" alt=""></div>
                </div>
              </div>
              <div class="row pt-4">
                <div class="col text-center">
                  <h4 class="almarai-bold">{{$t('mySubscription.subscriptionSuccessful')}}</h4>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col text-center">
                  <span class="p-content">{{$t('mySubscription.congratulations')}}</span>
                </div>
              </div>

              <div class="row py-4 justify-content-center">
                <div class="col-12 col-md-6 btn-black">
                  <router-link to="/">
                    <div class="text-white">{{$t('mySubscription.returnMain')}}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        <!-- end:subscription Successful Confirm -->
      </div>
    </div>
    <!-- begin:modal-payment -->
    <button type="button"  id="documentPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#documentModal">
      </button>
    <div class="modal fade" id="documentModal" tabindex="-1" aria-labelledby="documentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <button type="button" id="closeModal" class="btn-close p-3 m-0 d-none" data-bs-dismiss="modal" aria-label="Close"></button>
          
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-8 text-center">
                <div @click.prevent="paymentSelected" class="btn-gold">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:popup wallet balance -->
    <button type="button"  id="popup_Wallet" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance">
      </button>
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-direction">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-direction">
                {{price}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-direction">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-6 text-center" @click.prevent="featuredSubscrip">
                <div class="btn-black">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet?charge=true">
                  <div class="btn-gold fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

  </div>
</template>
<script>
import { mapGetters } from "vuex"
import moment from 'moment';
export default ({
  name: "mySubscription",
  data(){
    return{
      isLoading: true,
      hasError: false,
      message: "",
      errorNumber: null,
      row: {},
      user: {},
      date: null,
      price: null,
      isFeatured: null,
      paymentGate: "",
      remainingBalance: null,
      SuccessfulConfirm: false,
      min_loader: false,
      paymentLoading: false,
      userLang: 'ar',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL','USER_WALLET_BALANCE','GET_USER_DATA','BASE_URL'])
  },

  methods: {
    getFeaturedStatus(){
      this.$http.get('/api/users/featuredStatus').then(res => {
        this.row = res.data;
        this.price = res.data.price;
        this.user = res.data.user;
        this.date = res.data.user.featuredExpiryDate;
        this.isFeatured = res.data.user.isFeatured;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    featuredSubscrip(){
      this.hasError = false;
      this.$http.post('/api/users/featureSubscrip',{
        paymentGate: this.paymentGate
      }).then(res => {
        this.paymentLoading = false;
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          const confirmDiv = document.getElementById('popup_WalletBalance');
          if(confirmDiv && confirmDiv.style.display == 'block'){
            document.getElementById('closeWalletBalance').click();
          }
          this.SuccessfulConfirm = true;
          this.isFeatured = null;
          window.scrollTo({top:0, behavior: 'smooth'});

          if(this.paymentGate == 'wallet')
            this.$store.dispatch('checkUser');
        }
      }).catch(err => {
        // console.log(err);
        this.paymentLoading = false;
        // document.getElementById('documentModal').style.display = 'none';
        const paymentPopup = document.getElementById('documentModal');
        if(paymentPopup && paymentPopup.style.display == 'block'){
          document.getElementById('closeModal').click();
        }
        document.getElementById('closeWalletBalance').click();
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    paymentSelected(){
      this.paymentLoading = true;
      if(this.paymentGate == 'online'){
        this.featuredSubscrip();
      }else {
        this.paymentLoading = false;
        document.getElementById('documentPayment').click();
        if(this.price > this.USER_WALLET_BALANCE){
          document.getElementById('chargeWallet').style.display = 'block';
        }else{
          this.remainingBalance =  this.USER_WALLET_BALANCE - this.price;
          document.getElementById('popup_Wallet').click();
        }
      }
    },

    paymentMethod(){
      document.getElementById('documentPayment').click();
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },

    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime); 
    },
  },

  created(){
    this.getFeaturedStatus();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
})
</script>